import React, { ReactNode } from 'react';
import { ProductDetailTab } from '@features/product-detail/types.ts';

interface Tab {
  id: ProductDetailTab;
  label: string;
  badge?: ReactNode;
}

interface ProductTabsProps {
  tabs: Tab[];
  activeTabId: ProductDetailTab;
  onTabChange: (tabId: ProductDetailTab) => void;
}

const ProductTabs: React.FC<ProductTabsProps> = ({ tabs, onTabChange, activeTabId }) => {
  return (
    <div className="self-stretch h-12 inline-flex justify-start items-end gap-6">
      <div className="flex-1 flex justify-start items-start gap-6 overflow-hidden">
        {tabs.map((tab, tabIndex) => (
          <div
            key={tabIndex}
            className={`py-4 inline-flex flex-col justify-center items-center gap-4 cursor-pointer ${tab.id === activeTabId ? 'border-b-4 border-surface-dark-primary' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            <div className="inline-flex justify-start items-center gap-1">
              <div className={`text-base font-medium leading-none ${tab.id === activeTabId ? 'text-surface-dark-primary' : 'text-zinc-900'}`}>{tab.label}</div>
              {tab.badge && <>{tab.badge}</>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductTabs;
